import React from 'react';
import styled from 'astroturf/react';

import SpinnerIcon from './icons/spinner.svg';

const SpinnerWrapper = styled.div`
  @keyframes rotate-spinner {
    0% {
      transform: rotate(0deg);
    }
    33.33% {
      transform: rotate(90deg);
    }
    66.66% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  display: inline-block;
  position: relative;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: rotate-spinner 900ms linear infinite;
  }
`;

export type SpinnerProps = {
  size?: number;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 48 }) => {
  return (
    <SpinnerWrapper style={{ width: size, height: size }}>
      <SpinnerIcon />
    </SpinnerWrapper>
  );
};
